import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiRequestService, LogService, UseCase } from '@prekog/common-ui';
import { Observable } from 'rxjs';
import { GetProductRequest } from './get-product.request';
import { GetProductResponse } from './get-product.response';

@Injectable({ providedIn: 'root' })
export class GetProductUseCase extends UseCase<GetProductRequest, Observable<GetProductResponse>> {

    private _apiRequestService = inject(ApiRequestService);
    private _storeBaseUrl = inject<string>('STORE_BACKEND_URL' as never);
    private _getProductUrl = '/admin/get-product-by-routerlink';

    constructor(_logService: LogService, _http: HttpClient) {
        super(_logService, _http);
    }

    protected override executeBusinessLogic(request: GetProductRequest): Observable<GetProductResponse> | void {
        return this._apiRequestService.sendRequest<GetProductRequest, GetProductResponse>(
            this._storeBaseUrl,
            request,
            true,
            this._getProductUrl
        );
    }
}
